import { useCallback } from 'react'

import { FavoritesDrawer } from '../Components/FavoritesDrawer'
import { FavoritesDrawerStore } from '../Stores/FavoritesDrawerStore'

/** Публічне API контейнера для шапки: відкрити шухляду і сама шухляда. */
export const useFavoritesDrawer = () => {
    const openFavoritesDrawer = useCallback(() => {
        FavoritesDrawerStore.setIsOpen(true)
    }, [])

    return {
        openFavoritesDrawer,
        FavoritesDrawer,
    }
}
